import React from "react";

const AdminCategorySkeleton = ({ count = 8 }) => {
  return (
    <div className="my-6">
      <div className="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 gap-6">
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className="relative bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden animate-pulse"
          >
            {/* Image Skeleton */}
            <div className="w-full h-44 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-[pulse_1.5s_ease-in-out_infinite]"></div>

            {/* Content Skeleton */}
            <div className="p-5 space-y-3">
              <div className="h-5 bg-gray-200 rounded w-3/4"></div>
              <div className="h-4 bg-gray-200 rounded w-5/6"></div>
              <div className="h-4 bg-gray-200 rounded w-2/3"></div>
            </div>

            {/* Footer Action Buttons Skeleton */}
            {/* <div className="flex justify-center gap-3 pb-4">
              <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
              <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
              <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
            </div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminCategorySkeleton;
